'use client';

import { c as _c } from "react/compiler-runtime";
import ConnectButton from "../../_components/DpComponents/ConnectButton";
export default function GetInTouchBottomsheet(t0) {
  const $ = _c(5);
  const {
    digitalProfile
  } = t0;
  let t1;
  if ($[0] !== digitalProfile) {
    t1 = <ConnectButton digitalProfile={digitalProfile} placement="bottom_bar" />;
    $[0] = digitalProfile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className=" m-auto m3-body-small text-[--textPrimaryPrimary]"><strong>FREE Site Visit</strong>, on demand</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className="fixed w-full bottom-0 z-50 md:hidden h-[92px] rounded-t-2xl bg-white p-4 flex flex-col gap-2 justify-center items-center shadow-[0_-4px_16px_rgba(0,0,0,0.1)]">{t1}{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}